import { textSizeClasses } from "config/text-sizes";
import type { TextSize } from "config/text-sizes";
import {
  FieldSelect,
  type FieldSelectOption,
} from "containers/theme-setter/components/FieldSelect";
import { FieldInfoButton } from "containers/theme-setter/components/FieldInfoButton";
import type { ThemeFieldPreview } from "containers/theme-setter/types";

type TextVariantRowProps = {
  variantKey: string;
  mobile: string;
  desktop: string;
  onChange: (field: "mobile" | "desktop", value: string) => void;
  preview: ThemeFieldPreview;
};

const TEXT_SIZE_OPTIONS = Object.keys(textSizeClasses) as TextSize[];
const TEXT_SIZE_SELECT_OPTIONS: FieldSelectOption[] = [
  { value: "", label: "Default (inherit)" },
  ...TEXT_SIZE_OPTIONS.map((size) => ({
    value: size,
    label: size.toUpperCase(),
  })),
];

export const TextVariantRow = ({
  variantKey,
  mobile,
  desktop,
  onChange,
  preview,
}: TextVariantRowProps) => (
  <div className="rounded-md border border-border p-3">
    <div className="flex items-center gap-1.5">
      <p className="text-sm font-semibold tracking-wide text-white">
        {variantKey}
      </p>
      <FieldInfoButton label={variantKey} preview={preview} />
    </div>
    <div className="mt-3 grid gap-3 md:grid-cols-2">
      <FieldSelect
        label="Mobile"
        value={mobile}
        options={TEXT_SIZE_SELECT_OPTIONS}
        onChange={(value) => onChange("mobile", value)}
        labelClassName="text-gray-200"
      />
      <FieldSelect
        label="Desktop"
        value={desktop}
        options={TEXT_SIZE_SELECT_OPTIONS}
        onChange={(value) => onChange("desktop", value)}
        labelClassName="text-gray-200"
      />
    </div>
  </div>
);
